import { useQuery } from '@tanstack/react-query';

import { fetchMedicationConsistency } from '../../apis/medication';
import { useAppSelector } from '../../redux/hooks';

import { handleErrorResponse } from '../../utils/handleError';

const useFetchMedicationConsistency = (patientId: number | undefined) => {
  const authData = useAppSelector((state) => state.auth);
  const timeZone = authData?.constants?.timezone;

  const { data, isError, error, isLoading } = useQuery({
    queryKey: ['medication-consistency'],
    queryFn: () => fetchMedicationConsistency(patientId, timeZone),
  });

  if (isError) {
    handleErrorResponse(error, 'Error Fetching Medication Reminders');
  }

  return {
    isLoading,
    medicationConsistency: data || [],
  };
};

export default useFetchMedicationConsistency;
